export default function WhySmg() {
  return (
    <section
      id="why"
      className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/10 overflow-hidden"
      data-testid="why-smg-section"
    >
      <span
        className="pointer-events-none absolute -top-40 -right-40 w-[45vw] h-[45vw] rounded-full blur-3xl opacity-20"
        style={{ background: 'radial-gradient(closest-side, #FF3D2E, transparent 70%)' }}
      />
      <div className="relative grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-7">
          <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-[#FF3D2E] mb-6">
            — WHY SMG
          </p>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-white">
            Most agencies sell content.
            <br />
            <span className="text-white/40">SMG builds momentum.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 max-w-xl">
          <p className="text-white/80 text-lg leading-relaxed">
            We help brands identify the right audience, craft the right message, activate the right partnerships, and turn brand attention into revenue. Our approach combines creative strategy, data intelligence, cultural relevance, and business execution — engineered so every campaign compounds instead of resets.
          </p>
          <ul className="mt-8 space-y-3">
            {[
              'Brand strategy anchored to revenue, not vanity',
              'Partnership-first thinking across talent, media, and product',
              'AI + Strategic Intelligence built into every phase',
              'Culture-native storytelling with measurable outcomes',
            ].map((p) => (
              <li key={p} className="flex items-start gap-3 text-white/75 text-[15px]">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FF3D2E] shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
